import { ListPageLayout } from "@/components/list-page-layout";
import { usePageTitle } from "@/hooks/use-page-title";
import { AccountsDataTable } from "./accounts-data-table";

export default function AccountListView() {
  usePageTitle("Account List");

  return (
    <ListPageLayout
      pageType="accounts::list"
      title="Account List"
      className="max-w-full"
    >
      <AccountsDataTable />
    </ListPageLayout>
  );
}
